export default "__VITE_ASSET__CbVkU_nX__"